import {router} from "@/router/Router.ts";
import {RouteLocationNormalizedLoadedGeneric} from "vue-router";
import {StackPage} from "@t/meta/Stacker.ts";

/**
 * This helps preserve navigation stacker.
 * Sets index parameter in current window history (location)
 * @param index of current page in the stacker
 */
export function setStackerIndex(route: RouteLocationNormalizedLoadedGeneric | null | undefined, index: number): void {
    if (index < 0) return;
	if (router && route) {
		const url = router.resolve({
			path: route.path,
			query: {
				...route.query,
				_sidx_: index.toString()
			},
			hash: route.hash
		}).href;

		replaceCurrentHistoryUrl(url);
	} else {
		if (window.history) {
			const url = addParamToUrl(window.location.href, "_sidx_", "" + index);
			replaceCurrentHistoryUrl(url);
		}
	}
}

/**
 * Ensure that URL in the browser address line is in sync with the current stack page
 * @param index - current page index
 * @param pg - current stacker page
 */
export async function syncBrowserHistoryWithStackPage(index:number, url:string):Promise<void> {
	if (index < 0) return;
	if (window.history) {
		url = addParamToUrl(url, "_sidx_", "" + index);
		replaceCurrentHistoryUrl(url);
	}
}

function replaceCurrentHistoryUrl(url: string): void {
	const state = window.history.state;
	const relativeUrl = toRelativeUrl(url);
	const nextState = state && typeof state === "object"
		? {
			...state,
			current: relativeUrl
		}
		: {
			current: relativeUrl
		};

	// Keep Vue Router's current history entry consistent without triggering a router navigation.
	window.history.replaceState(nextState, "", url);
}

function toRelativeUrl(url: string): string {
	const parsed = new URL(url, window.location.href);
	return parsed.pathname + parsed.search + parsed.hash;
}

function addParamToUrl(url: string, name: string, value: string): string {
	const parsed = new URL(url, window.location.href);
	parsed.searchParams.set(name, value);
	return parsed.pathname + parsed.search + parsed.hash;
}